import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './CalendlyModal.css';

function CalendlyModal({ isOpen, onClose }) {
  const widgetRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      // Load Calendly script if not already loaded
      const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
      
      const loadCalendly = () => {
        if (window.Calendly && widgetRef.current) {
          // Clear any existing content
          widgetRef.current.innerHTML = '';
          
          // Initialize the inline widget
          window.Calendly.initInlineWidget({
            url: 'https://calendly.com/ugc3/call',
            parentElement: widgetRef.current,
            prefill: {},
            utm: {}
          });
        }
      };

      if (!existingScript) {
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        script.onload = () => {
          // Wait a bit for Calendly to be fully ready
          setTimeout(loadCalendly, 100);
        };
        document.body.appendChild(script);
      } else {
        // Script already exists, try to initialize
        if (window.Calendly) {
          setTimeout(loadCalendly, 100);
        } else {
          // Wait for script to be ready
          const checkCalendly = setInterval(() => {
            if (window.Calendly) {
              clearInterval(checkCalendly);
              loadCalendly();
            }
          }, 100);
          
          return () => clearInterval(checkCalendly);
        }
      }
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const modalContent = (
    <div className="calendly-modal-overlay" onClick={onClose}>
      <div className="calendly-modal" onClick={(e) => e.stopPropagation()}>
        <button className="calendly-modal-close" onClick={onClose}>
          ×
        </button>
        <div className="calendly-modal-content">
          <h2 className="calendly-modal-title">Book a Call</h2>
          <div 
            ref={widgetRef}
            className="calendly-inline-widget-container"
          />
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
}

export default CalendlyModal;

